/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserTagFollowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserTagFollowsQuery = { __typename: 'Query', getUserTagFollows: Array<{ __typename: 'TagFollow', id: string | null, user_id: string | null, tag_id: string | null }> | null };


export const GetUserTagFollowsDocument = gql`
    query getUserTagFollows {
  getUserTagFollows {
    id
    user_id
    tag_id
  }
}
    `;

/**
 * __useGetUserTagFollowsQuery__
 *
 * To run a query within a React component, call `useGetUserTagFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTagFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTagFollowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTagFollowsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTagFollowsQuery, GetUserTagFollowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTagFollowsQuery, GetUserTagFollowsQueryVariables>(GetUserTagFollowsDocument, options);
      }
export function useGetUserTagFollowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTagFollowsQuery, GetUserTagFollowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTagFollowsQuery, GetUserTagFollowsQueryVariables>(GetUserTagFollowsDocument, options);
        }
export type GetUserTagFollowsQueryHookResult = ReturnType<typeof useGetUserTagFollowsQuery>;
export type GetUserTagFollowsLazyQueryHookResult = ReturnType<typeof useGetUserTagFollowsLazyQuery>;